import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["color:#000;cursor:pointer;text-decoration:none;"]);
/**
 * Renders an `a` element with some default styles. Useful for when you don't
 * need a React Router [Link](https://reacttraining.com/react-router/web/api/Link)
 * or Pantheon's [NavLink](#navlink) which wraps a React Router's `Link`.
 *
 * @public
 * @author Connor Taylor
 */

var Link = makeThemedComponent({
  themeKey: "Link",
  component: "a",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default Link;